/*
 * File: input-file-classic.ts
 * File Created: 2024-02-17 10:00:59
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import { BaseInputComponent } from "@root/components/inputs/core/lib";
import { PropInnateSync } from "@root/core/vue-props";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class InputFileClassic extends BaseInputComponent {
    @PropInnateSync("value", { type: [File, Array], default: undefined })
    innateValue!: File | File[] | undefined;

    @Prop({ type: String, default: "w_IFCNoFileChosen" })
    declare placeholder: string;

    @Prop({ type: String, default: "*/*" })
    contentType!: string;

    /// private helper
    private static subscription;
    created() {
        /// do only once
        if (InputFileClassic.subscription) return;
        InputFileClassic.subscription = this.$lang.getObservable().subscribe((value) => {
            document.documentElement.style.setProperty(
                "--browse-text",
                `"${this.$lang.translate("w_Browse")}"`,
            );
        });
    }
}
